import { SERVICES } from "#/lib/constants";
import { Icon } from "#/components/shared/Icon";
import { SectionLabel } from "#/components/shared/SectionLabel";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";

/**
 * /services — icon-card grid, mirrored from the client reference (light
 * 3-column cards: line icon top-left, bold title, short blurb, dark
 * rectangular button). Palette swapped per the project rule: reference red ->
 * flame, reference dark button -> graphite. Button label per client: "Show
 * More". The whole card is one link; the button is the visual affordance.
 */
export function ServiceCardGrid() {
  const { ref, isVisible } = useScrollAnimation(0.05);

  return (
    <section className="bg-light-bg py-20 lg:py-28">
      <div ref={ref} className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <SectionLabel>What We Do</SectionLabel>
          <h2 className="mt-4 font-heading text-3xl font-extrabold leading-[1.1] text-graphite sm:text-4xl lg:text-5xl">
            Eight services, one standard of work.
          </h2>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service, i) => (
            <a
              key={service.slug}
              href={`#${service.slug}`}
              className={`group flex flex-col items-start rounded-lg bg-white p-8 no-underline shadow-sm ring-1 ring-graphite/5 transition-all duration-500 hover:shadow-lg ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}
              style={{ transitionDelay: isVisible ? `${i * 60}ms` : "0ms" }}
            >
              <Icon name={service.icon} className="h-10 w-10 text-flame" />
              <h3 className="mt-6 font-heading text-xl font-bold tracking-tight text-graphite sm:text-2xl">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-graphite/70">
                {service.blurb}
              </p>
              <span className="mt-6 inline-flex bg-graphite px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition-colors group-hover:bg-flame">
                Show More
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
